import { render, staticRenderFns } from "./StudentStatusInput.vue?vue&type=template&id=34a69e04&scoped=true"
import script from "./StudentStatusInput.vue?vue&type=script&lang=ts"
export * from "./StudentStatusInput.vue?vue&type=script&lang=ts"
import style0 from "./StudentStatusInput.vue?vue&type=style&index=0&id=34a69e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a69e04",
  null
  
)

export default component.exports